<template>

  <v-row dense v-if="order">
    <v-col cols="12" class="text-left">
      <v-list dense>

        <v-list-item>
          <v-list-item-avatar size="30">
            <v-icon>shopping_cart</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            {{ $t('delivery.cart.products') }}:
          </v-list-item-content>
          <v-list-item-action-text>
            <v-list-item-title>
              {{ currencyFormat(order.itemsAmount) }}
            </v-list-item-title>
          </v-list-item-action-text>
        </v-list-item>

        <v-list-item v-if="order.delivery.cost">
          <v-list-item-avatar size="30">
            <v-icon>delivery_dining</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            {{ $t('delivery.cart.deliveryCost') }}:
          </v-list-item-content>
          <v-list-item-action-text>
            <v-list-item-title>
              <span v-if="order.deliveryFree" class="text-decoration-line-through grey--text">
                  {{ currencyFormat(order.delivery.cost) }}
              </span>
              <span v-else>{{ currencyFormat(order.delivery.cost) }}</span>
            </v-list-item-title>
          </v-list-item-action-text>
        </v-list-item>

        <v-list-item v-if="order.totalDiscount">
          <v-list-item-avatar size="30">
            <v-icon>discount</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            {{ $t('delivery.cart.discount') }}:
          </v-list-item-content>
          <v-list-item-action-text>
            <v-list-item-title>
              <span v-if="order.discountRate > 0" class="mr-3 font-weight-thin">(-{{order.discountRate}}%)</span> <b>-{{
                currencyFormat(order.totalDiscount)
              }}</b>
            </v-list-item-title>
          </v-list-item-action-text>
        </v-list-item>

        <v-list-item>
          <v-list-item-avatar size="30">
            <v-icon>payments</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            {{ $t('delivery.cart.total') }}:
          </v-list-item-content>
          <v-list-item-action-text>
            <v-list-item-title>
                <span v-if="order.totalDiscount > 0" class="text-decoration-line-through grey--text">
                  {{currencyFormat(order.totalAmount + order.totalDiscount) }}
                </span>
                <b> {{currencyFormat(order.totalAmount)}}</b>
            </v-list-item-title>
          </v-list-item-action-text>
        </v-list-item>

      </v-list>

    </v-col>


  </v-row>
</template>

<script>
import CurrencyMixin from "@/modules/delivery/mixins/CurrencyMixin";

export default {
  name: "CartTotal",
  mixins:[CurrencyMixin],
  props: {
    order: {type: Object},
  },

}
</script>

<style scoped>

</style>
